import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box, Alert } from '@mui/material';

const AddServiceTypeDialog = ({ open, onClose, onAdd }) => {
  const [form, setForm] = useState({
    type_description: '',
    time_cost: '',
    charge: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await onAdd(form);
      setForm({ type_description: '', time_cost: '', charge: '' });
    } catch (err) {
      setError(err.message || 'Failed to add service type');
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Add Service Type</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error">{error}</Alert>}
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <TextField label="Type Description" name="type_description" value={form.type_description} onChange={handleChange} fullWidth margin="normal" required />
          <TextField label="Time Cost" name="time_cost" value={form.time_cost} onChange={handleChange} fullWidth margin="normal" required />
          <TextField label="Charge" name="charge" value={form.charge} onChange={handleChange} fullWidth margin="normal" required type="number" />
          <DialogActions>
            <Button onClick={onClose} disabled={loading}>Cancel</Button>
            <Button type="submit" variant="contained" color="primary" disabled={loading}>
              {loading ? 'Saving...' : 'Add Service Type'}
            </Button>
          </DialogActions>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AddServiceTypeDialog; 